export default __webpack_public_path__ + "static/media/morocco3.b22bf146.jpg";